<template>
  <operator-table
      :orders="orders"
      :pagination="pagination"
      :headers="headers"
      @getData="getDataWalking"
      @doAction="doAction"
  >
  </operator-table>
</template>

<script>
import {eventBus} from '@/main';
import OperatorOrdersService from "@/services/Operator/OperatorOrders";
import OperatorTable from "@/components/Operator/OperatorTable";

export default {
  name: 'OperatorOrders',
  components: {OperatorTable},
  data() {
    return {
      orders: [],
      pagination: {
        visible: 5
      },
      headers: [
        {text: 'Order #', value: 'id', sortable: false},
        {text: 'User', value: 'name'},
        {text: 'Phone', value: 'phone'},
        {text: 'Created', value: 'created'},
        {text: 'Total amount', value: 'total_amount'},
        {text: 'Action', value: 'action'}
      ],
    }
  },
  created() {
    eventBus.$on('do-operator-search', this.getDataWalking);
  },
  beforeDestroy() {
    eventBus.$off('do-operator-search', this.getDataWalking);
  },
  mounted() {
    this.getDataWalking()
  },
  methods: {
    getDataWalking(searchData) {
      let url = ''
      for (let param in this.$router.currentRoute.query) {
        url += '&' + param + "=" + this.$router.currentRoute.query[param]
      }
      if ((typeof searchData === 'string' || searchData instanceof String) && searchData.trim().length > 0) {
        url += '&search=' + searchData.trim();
      }
      this.$store.commit('setLoading', true);
      OperatorOrdersService.getOrders(this.pagination.page, url)
          .then(response => {
            if (response.status === this.$response.Ok) {
              this.orders = response.data.data
              this.pagination.page = response.data.meta.current_page
              this.pagination.total = response.data.meta.total
              this.pagination.perPage = response.data.meta.per_page
              this.pagination.lastPage = response.data.meta.last_page
              this.$router.push('/operator/orders/' + this.pagination.page)
            }
          })
          .catch(error => {
            this.$store.commit('setError', error.response);
          })
          .finally(() => {
            this.$store.commit('setLoading', false);
          })
    },
    doAction(item) {
      if (this.loading) {
        return;
      }
      this.$store.commit('setLoading', true);
      OperatorOrdersService.updateOrder(item.id)
          .then(response => {
            if (response.status === this.$response.Ok) {
              this.getDataWalking();
            }
          })
          .catch(error => {
            this.$store.commit('setError', error.response);
            this.$store.commit('setLoading', false);
          })
    },
  },
  computed: {
    loading() {
      return this.$store.getters.loading;
    }
  }
}
</script>
